import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-372ab9c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-card" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "image" }
const _hoisted_4 = ["src"]

import { IProduct, BASE_URL } from '@/model/Product';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  product: { type: Object as PropType<IProduct | undefined>, default: () => undefined },
},
  emits: ['reset'],
  setup(__props, { emit: emits }) {

const props = __props





return (_ctx: any,_cache: any) => {
  return (__props.product)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "info-product",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reset')))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "info-description",
            innerHTML: __props.product?.description_base
          }, null, 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _unref(BASE_URL) + __props.product?.photo,
              alt: ""
            }, null, 8, _hoisted_4)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})